import React from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import "./index.scss";

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    margin: theme.spacing(0),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(0)
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    float: "right"
  },
  formControl: {
    minWidth: "100%"
  },
  mBottom: {
    marginBottom: "20px"
  },
  mTop: {
    marginTop: "5px"
  },
  button: {
    margin: theme.spacing(3, 0, 2)
  }
}));

export default function Occupation() {
  const classes = useStyles();

  const [age, setAge] = React.useState("");

  const handleChange = event => {
    console.log(setAge(event.target.value));
  };

  return (
    <Container component="main" maxWidth="md">
      <CssBaseline />
      <div className={classes.paper}>
        <form className={classes.form} noValidate>
          <Grid item xs={12} className={classes.mBottom}>
            <Typography>Let us know about your Occupational status</Typography>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="surname"
                name="surname"
                variant="outlined"
                required
                fullWidth
                id="surName"
                label="Work experience after education"
                autoFocus
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                pocc="surname"
                name="surname"
                variant="outlined"
                required
                fullWidth
                id="pocc"
                label="Present Occupation"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="surname"
                name="surname"
                variant="outlined"
                required
                fullWidth
                id="surName"
                label="Does family agree with your choice?"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel id="">How is God calling you?</InputLabel>
                  <Select
                    fullWidth
                    labelId="how"
                    id=""
                    value={age}
                    onChange={handleChange}
                    label="Age"
                  >
                    <MenuItem value="brother">As a Lay brother</MenuItem>

                    <MenuItem value="priest">As a Priest</MenuItem>
                  </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Typography>
                DESCRIBE ANY CONTACT OR EXPERIENCE WITH OTHER RELIGIOUS
                CONGREGATIONS OR IN A DIOCESAN SEMINARY
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                id="outlined-multiline-static"
                label="Describe"
                multiline
                rows={4}
                // defaultValue="Default Value"
                variant="outlined"
                className={classes.form}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography>
                FROM WHERE DID YOU GET INFORMATION ABOUT CAPUCHIN FRANCISCAN
                VOCATION
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel id="">Select where</InputLabel>
                  <Select
                    fullWidth
                    labelId="vocation"
                    id=""
                    value={age}
                    onChange={handleChange}
                    label="Age"
                  >
                    <MenuItem value="capuchin friar(s)">
                      CAPUCHIN FRIAR(S)
                    </MenuItem>
                    <MenuItem value="friend(s)">FRIEND(S)</MenuItem>
                    <MenuItem value="publication(s)">PUBLICATION(S)</MenuItem>
                    <MenuItem value="internet">INTERNET</MenuItem>
                  </Select>
                </FormControl>
            </Grid>
          </Grid>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.button}
            component={Link}
            to="upload-document"
          >
            Back
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.submit}
            component={Link}
            to="autobiography"
          >
            Next
          </Button>
        </form>
      </div>
    </Container>
  );
}
